import { render } from "./MigrateImageStoreResource.vue?vue&type=template&id=fe3d5206&scoped=true"
import script from "./MigrateImageStoreResource.vue?vue&type=script&lang=js"
export * from "./MigrateImageStoreResource.vue?vue&type=script&lang=js"

import "./MigrateImageStoreResource.vue?vue&type=style&index=0&id=fe3d5206&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe3d5206"]])

export default __exports__